import React from "react";
import { MenuItem, SubMenu } from "react-pro-sidebar";
import { useNavigate } from "react-router-dom";

function AdminMenu() {
  const navigate = useNavigate();
  const Link = ({ to, className, children }) => (
    <span
      className={className}
      role="link"
      tabIndex={0}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        navigate(to);
      }}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          event.stopPropagation();
          navigate(to);
        }
      }}
    >
      {children}
    </span>
  );

  return (
    <>
      <SubMenu
        label={<span>Settings</span>}
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.4277 2C11.3139 2 10.2995 2.6007 8.27081 3.80211L7.58466 4.20846C5.55594 5.40987 4.54158 6.01057 3.98466 7C3.42773 7.98943 3.42773 9.19084 3.42773 11.5937V12.4063C3.42773 14.8092 3.42773 16.0106 3.98466 17C4.54158 17.9894 5.55594 18.5901 7.58466 19.7915L8.27081 20.1979C10.2995 21.3993 11.3139 22 12.4277 22C13.5416 22 14.5559 21.3993 16.5847 20.1979L17.2708 19.7915C19.2995 18.5901 20.3139 17.9894 20.8708 17C21.4277 16.0106 21.4277 14.8092 21.4277 12.4063V11.5937C21.4277 9.19084 21.4277 7.98943 20.8708 7C20.3139 6.01057 19.2995 5.40987 17.2708 4.20846L16.5847 3.80211C14.5559 2.6007 13.5416 2 12.4277 2ZM8.67773 12C8.67773 9.92893 10.3567 8.25 12.4277 8.25C14.4988 8.25 16.1777 9.92893 16.1777 12C16.1777 14.0711 14.4988 15.75 12.4277 15.75C10.3567 15.75 8.67773 14.0711 8.67773 12Z"
              fill="white"
            />
          </svg>
        }
        className={"safety"}
      >
        <SubMenu label={<span>Account Setup</span>} className={"safety"}>
          <MenuItem icon={<span>&#10070;</span>} className="entity">
            <Link className="dropdown-item" to={"/saas/admin_billing"}>
              Billing
            </Link>
          </MenuItem>
        </SubMenu>
      </SubMenu>
    </>
  );
}

export default AdminMenu;
